// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16lP4","icon":"styles_icon__3I3k-"};